<template></template>

<script>
import { Timeline } from '@/utils/TimelineAudio'

export default {
  props: {
    slides: {
      type: Array,
      default: () => {return []}
    },
    currentIndex: {
      type: Number,
      default: -1
    }
  },
  data () {
    return {
      isPlaying: false
    }
  },
  created () {
    this.player = document.createElement("audio")
    this.player.pause()
    if (this.$route.query.debug) {
      this.player.volume = .05
    }
    this.time = 0

    this.$hub.on('player:play', this.onPlay)
    this.$hub.on('player:pause', this.onPause)

    this.player.addEventListener('ended', () => {
      this.$emit('onNext')
    })

    this.timeline = new Timeline(this.callback)
    this.timeline.start()
    this.onCustomUpdate()
  },

  methods: {
    onUpdate () {
      if (this.currentIndex !== -1) {
        this.timeline.onUpdate(this.player.currentTime)
      }
    },
    onCustomUpdate () {
      const time = this.player.currentTime

      if (time === this.time) {
        this.isPlaying = false 
      }
      else {
        this.isPlaying = true
      }

      this.time = time

      this.timeoutUdpate = setTimeout(this.onCustomUpdate, 150)
    },
    callback (data) {
      // ICI ON ENVOIE LES EVENT POUR FAIRE BOUGER LE TRUC 3D
      this.$hub.emit('animation', data.markName)
    },
    onUpdateSrc () {
      if (this.currentIndex === -1 ) {return}
      this.player.src = this.slides[this.currentIndex].generatedVoiceUrl
      this.timeline.clearData()
      this.timeline.setData(this.slides[this.currentIndex].timecodes)
    },
    onPlay () {
      this.player.play()
    },
    onPause () {
      this.player.pause()
    }
  },

  beforeDestroy () {
    this.$hub.off('player:play', this.onPlay)
    this.$hub.off('player:pause', this.onPause)
    clearTimeout(this.timeoutUdpate)
  },

  watch: {
    currentIndex () {
      this.onUpdateSrc()
    },
    slides () {
      this.onUpdateSrc()
    },
    isPlaying () {
      if (this.isPlaying) {
        this.$hub.emit('player:onPlay')
      }
      else {
        this.$hub.emit('player:onPause')
      }
    }
  }
}
</script>

<style lang="stylus">
  
</style>